export default __webpack_public_path__ + "static/stars-gray-778ee0d067dfa340dceaeeab3806aae4.png";